module.exports = __webpack_public_path__ + "img/marker_two_cyan2.9a7bebdf.png";